//import FirebaseLogin from './login/FirebaseLogin';
import AuthClass from './login/AuthClass';
import NotFound from './NotFound';
import ForgotPassword from './ForgotPassword';
//import FirebaseRegister from './register/FirebaseRegister';

const sessionRoutes = [
  //{
  //  path: '/session/signup',
  //  component: FirebaseRegister,
  //},
  {
    path: '/session/signin',
    component: AuthClass,
    //component: FirebaseLogin,
  },
  {
    path: '/session/forgot-password',
    component: ForgotPassword,
  },
  {
    path: '/session/404', //不使用 → <Redirect to="/dashboard"
    component: NotFound,
  },
];

export default sessionRoutes;
